const normalizeCurrency = (value) => {
  if (!value) {
    return value;
  }
  if (value === '$') {
    return null;
  }

  const onlyNums = +value.replace(/[^\d]/g, '');
  return `$${onlyNums}`;
};


export default normalizeCurrency;

export const normalizeFHA = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 10) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 10)}`;
};
